export class PnlExposure {
	eventId: any;
	pnlBySelection: any;
}
